$(function() {
$(window).scroll(function () {
   if ($(this).scrollTop() > 900) {
      $('.product-template').addClass('change-color')
   } 
   if ($(this).scrollTop() < 900) {
      $('.product-template').removeClass('change-color')
   } 
});
});



$(document).ready(function(){
        $('[name="day"]').change(function(){
            if($('[name="day"]:checked').is(":checked")){
                $('.am').hide();
                $('.pm').show();
            }else{
                $('.am').show();
                $('.pm').hide();
            }
        });
    });

$('.metafield-rich_text_field h4').each(function() {
  $(this).addClass('h4-dd');
  $(this).addClass('not-active');
});

$('.metafield-rich_text_field h4 + p').each(function() {
  $(this).nextUntil('.metafield-rich_text_field h4')
         .addBack()
         .wrapAll("<div class='panel' />");
});


const items = document.querySelectorAll(".h4-dd");
function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded'); 
  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }  
  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}
items.forEach(item => item.addEventListener('click', toggleAccordion));








